export type StatusType = 'Tetap' | 'Kontrak' | 'Probation' | 'Magang';

export interface Employee {
    id: string;
    name: string;
    nik: string;
    status: string;
    joinDate: string;
    position: string;
    contractDivisi: string;
    contractYear?: number;
}

export interface Employee2 {
  id: number;
  nik: string;
  nama: string;
  foto_karyawan: string;
  inisial: string;
  jk: string;
  agama: string;
  tgl_lahir: string;
  tgl_lahir_formatted: string;
  usia: number;
  kode_pos: string;
  alamat_rumah: string;
  alamat_sekarang: string;
  no_hp_perusahaan: string | null;
  no_hp_pribadi: string;
  email: string;
  tgl_bergabung: string;
  tgl_bergabung_formatted: string;
  periode_kontrak: string | null;
  lama_kerja: number;
  lokasi_kerja: string;
  jabatan: string;
  divisi: string;
  kota: string;
  npwp: string | null;
  rekening: Record<string, string>;
  pendidikan: {
    jenjang: string;
    institusi: string;
    jurusan: string;
    tahun_lulus: number | null;
  };
  bidang_keahlian: string;
  resign: {
    tanggal_keluar: string;
    alasan: string;
    keterangan: string;
  } | null;
  status_pegawai: StatusType;
}

export const EMPTY_KARYAWAN: Omit<Employee2, 'id'> = {
  nik: '', nama: '', foto_karyawan: '', inisial: '', jk: '', agama: '', tgl_lahir: '', tgl_lahir_formatted: '', usia: 0,
  kode_pos: '', alamat_rumah: '', alamat_sekarang: '', no_hp_perusahaan: null, no_hp_pribadi: '',
  email: '', tgl_bergabung: '', tgl_bergabung_formatted : '', periode_kontrak: null, lama_kerja: 0, status_pegawai: 'Tetap',
  lokasi_kerja: '', jabatan: '', divisi: '', kota: '', npwp: null, rekening: {}, 
  pendidikan: { jenjang: '', institusi: '', jurusan: '', tahun_lulus: null }, bidang_keahlian: '',
  resign: null
};